import { Injectable, OnDestroy, signal, inject } from '@angular/core';
import { ApiService } from './api.service';
import { ApiServiceHolder } from '../utils/api-service-holder';
import { AuthService } from './auth.service';
import { Subscription } from 'rxjs';

interface PendingPaymentDto {
  guidPayment: string;
  checkoutUrl: string;
  providerStatus: string;
  idPaymentType: number;
}

@Injectable({ providedIn: 'root' })
export class PendingPaymentService implements OnDestroy {
  private sub?: Subscription;

  readonly hasPending = signal<boolean>(false);
  readonly checkoutUrl = signal<string | null>(null);

  private readonly api = inject(ApiService);
  private readonly authService = inject(AuthService);

  /**
   * Refresh pending payment state by querying backend first-pending endpoint.
   * Safe to call frequently; in-flight request (if any) will be unsubscribed.
   */
  refresh(): void {
    if (!this.authService.isAuthenticated()) {
      this.clear();
      return;
    }

    // Cancel previous in-flight request to avoid race conditions.
    this.sub?.unsubscribe();
    this.sub = this.api
      .request<PendingPaymentDto | null>(
        ApiServiceHolder.auctionpayment.firstPending()
      )
      .subscribe({
        next: (pending) => {
          if (pending && pending.checkoutUrl) {
            this.hasPending.set(true);
            this.checkoutUrl.set(pending.checkoutUrl);
          } else {
            this.clear();
          }
        },
        error: () => this.clear(),
      });
  }

  /** Clear state (no pending payment). */
  clear(): void {
    this.hasPending.set(false);
    this.checkoutUrl.set(null);
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
